import Modal from '../../../base/pages/consumption/Modal';

const modal: Modal = {
  noDataTitle: 'The selected range contains no data',
  noDataMessage: ''
};

export default modal;
